export const getFromLocalStorage = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error("Error getting value from local storage:", error);
    return null;
  }
};

export const setInLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error setting value in local storage:", error);
  }
};

export const removeFromLocalStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error("Error removing value from local storage:", error);
  }
};

export function downloadPDF(pdfContent) {
  const pdfBlob = new Blob([pdfContent], { type: "application/pdf" });
  const url = URL.createObjectURL(pdfBlob);
  const a = document.createElement("a");
  a.href = url;
  const now = new Date();
  const dateString = now.toISOString().split("T")[0];
  const timeString = now.toTimeString().split(" ")[0].replace(/:/g, "");
  const filename = `${dateString}_${timeString}.pdf`;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadExcelFile(responseData) {
  const blob = new Blob([responseData], {
    type: "application/xlsx",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const now = new Date();
  const dateString = now.toISOString().split("T")[0];
  const timeString = now.toTimeString().split(" ")[0].replace(/:/g, "");
  const filename = `${dateString}_${timeString}.xlsx`;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
